import { BASE_URL } from '../../../../../utils/config.base-url'

export const URL_ENDPOINT_USER = `${BASE_URL}/user`

export const USER_PREFIX_URL = '/user'
